import React from 'react';
import { render } from 'react-dom';
//import LoginFirebase from './routes/LoginFirebase';
import App from './App';

//render (<LoginFirebase key="LoginFirebase" />, document.getElementById('root'));
render(<App key="App" />, document.getElementById('root'));
